/*
  Apollo State name for sharing cached data
*/
export const APOLLO_STATE_PROP_NAME = "__APOLLO_STATE__";

/*
  Avro v4 event name for plan change interactions
*/
export const PLAN_CHANGE_EVENT =
  "schema:billing.account.plan.PlanChangeUserInteractionEvent";

/*
  Standard event data for when a geolocated currency is loaded
*/
export const geoCurrencyLoadedEventData = {
  event_action: "select_currency",
  interaction_goal: "select currency",
  interaction_name: "geolocated currency loaded",
};

/*
  Default country code for user geo location provided by Vercel headers
*/
export const DEFAULT_COUNTRY_CODE = "US";

export const DEFAULT_ANNUAL_DISCOUNT_PERCENTAGE = 33;

export const BUILDER_MODELS = {
  pricingFaq: "pricing-faq",
  pricingPageSection: "pricing-page-section",
};

export const BUILDER_UNIQUE_IDENTIFIERS = {
  pricingFaq: "pricing-faq",
};

/**
 * Default account ID to be used Logged Out when /pricing needs a single default behavior
 */
export const DEFAULT_ACCOUNT_ID = "1";

/*
  Builder unique identifiers for the pricing-page-section Model
*/
// logged-in page tables CTA banner
export const TABLES_CTA_BANNER = "tables-cta-banner";
// Builder pricing page FAQ
export const PRICING_FAQ = "pricing-faq";

/**
 * Split feature flags
 */
export const FEATURE_TABLES_SPLIT_NAME = "revenue_growth_feature-tables-flag";
export const REVENUE_GROWTH_NEW_DOWNGRADE = "revenue_growth_new_downgrade";
export const COMPANY_CTA_FEAT_FLAG = "experiment_company-card-contact-sales";
export const TRIAL_RECOMMENDATIONS_FLAG = "experiment_trial-recommendations";
